import React from "react";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {
    IFreePlayVoucherViewModel
} from "../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardFaceBox} from "../../../boxes/voucher-card/face/voucher-card-face.box";
import {VoucherCardFaceContentBox} from "../../../boxes/voucher-card/face/content/voucher-card-face-content.box";
import {VoucherCardFaceFooterBox} from "../../../boxes/voucher-card/face/footer/voucher-card-face-footer.box";
import {VoucherCardFaceIconContainerBox} from "../../../boxes/voucher-card/face/content/icon/voucher-card-face-icon-container.box";
import {
    VoucherCardFaceDetailsBox
} from "../../../boxes/voucher-card/face/content/details/voucher-card-face-details.box";
import {
    VoucherCardFaceOriginalAmountBox
} from "../../../boxes/voucher-card/face/content/details/original-amount/voucher-card-face-original-amount.box";
import {
    VoucherCardFaceVoucherNameBox
} from "../../../boxes/voucher-card/face/content/details/name/voucher-card-face-voucher-name.box";
import {
    VoucherCardFaceCurrentAmountContainerBox
} from "../../../boxes/voucher-card/face/content/details/current-amount/voucher-card-face-current-amount-container.box";
import {observer} from "mobx-react";
import {VoucherCardFaceIconBox} from "../../../boxes/voucher-card/face/content/icon/voucher-card-face-icon.box";
import {
    VoucherCardFaceCurrentAmountBox
} from "../../../boxes/voucher-card/face/content/details/current-amount/voucher-card-face-current-amount.box";
import {
    VoucherCardSideToggleButtonBox
} from "../../../boxes/voucher-card/common/footer/side-toggle/voucher-card-side-toggle-button.box";
import {
    VoucherCardSideFooterContentBox
} from "../../../boxes/voucher-card/common/footer/footer-content/voucher-card-side-footer-content.box";
import { SvgSizeUnit } from "../../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {VoucherCardFaceHeaderComponent} from "./voucher-card-face-header.component";

interface VoucherCardFaceComponentProps {
    voucher: IFreePlayVoucherViewModel;
    onToggleSide?: () => void;
    onClick?: () => void;
    backSideShown: boolean;
    backgroundImageUrl: string;
}


@observer
export class VoucherCardFaceComponent extends OrbitComponent<VoucherCardFaceComponentProps> {

    private _renderOriginalAmount() {
        return (
            <VoucherCardFaceOriginalAmountBox>
                {this.props.voucher.formattedOriginalAmount || this.props.voucher.formattedCurrentBalance}
            </VoucherCardFaceOriginalAmountBox>
        )
    }

    private _renderCurrentAmount() {
        if(!this.props.voucher.formattedOriginalAmount) {
            return null;
        }

        return (
            <VoucherCardFaceCurrentAmountContainerBox>
                <span>
                    {this.services.translation.translate('FREE_PLAY_VOUCHER_BALANCE_PREFIX')}
                </span>
                <VoucherCardFaceCurrentAmountBox>
                    {this.props.voucher.formattedCurrentBalance}
                </VoucherCardFaceCurrentAmountBox>
            </VoucherCardFaceCurrentAmountContainerBox>
        );
    }

    render() {
        let InfoIcon = this.services.theme.currentTheme.icons.infoIcon;
        return (
            <VoucherCardFaceBox backgroundImageUrl={this.props.backgroundImageUrl} backSideShown={this.props.backSideShown}>
               <VoucherCardFaceHeaderComponent voucher={this.props.voucher} onClick={this.props.onClick}/>

                <VoucherCardFaceContentBox onClick={this.props.onClick}>
                    <VoucherCardFaceIconContainerBox>
                        <VoucherCardFaceIconBox iconUrl={this.props.voucher.iconUrl}/>
                    </VoucherCardFaceIconContainerBox>
                    <VoucherCardFaceDetailsBox>
                        {this._renderOriginalAmount()}
                        <VoucherCardFaceVoucherNameBox>
                            {this.props.voucher.voucherName}
                        </VoucherCardFaceVoucherNameBox>
                        {this._renderCurrentAmount()}
                    </VoucherCardFaceDetailsBox>
                </VoucherCardFaceContentBox>

                <VoucherCardFaceFooterBox>
                    <VoucherCardSideToggleButtonBox onClick={this.props.onToggleSide}>
                        <InfoIcon size={1.4} sizeUnit={SvgSizeUnit.Rem} />
                    </VoucherCardSideToggleButtonBox>
                    <VoucherCardSideFooterContentBox onClick={this.props.onClick}/>
                </VoucherCardFaceFooterBox>

            </VoucherCardFaceBox>
        )
    }
}